import { Button } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { getUiLanguage, setUiLanguage } from '../lib/i18n';

/** Interface language switch: the OTHER language's name; one click switches and reloads. */
export function LanguageButton({ compact = false }: { labeled?: boolean; compact?: boolean } = {}) {
  const next = getUiLanguage() === 'ar' ? 'en' : 'ar';
  return (
    <Button
      variant="subtle"
      color="gray"
      c="dark.6"
      leftSection={<IconLanguage size={17} stroke={1.7} />}
      onClick={() => {
        setUiLanguage(next);
        window.location.reload();
      }}
      lang={next}
      aria-label={next === 'en' ? 'English' : 'العربية'}
      px={compact ? 'xs' : 'sm'}
    >
      {next === 'en' ? 'English' : 'العربية'}
    </Button>
  );
}
